import entitiesSelector from './entities_selector';

const teachersSelector = entitiesSelector(
  state => state.teachers,
  (teacher, localState, associations) => {
    let displayName;
    let initials;
    if(teacher.first_name && teacher.last_name) {
      displayName = `${teacher.first_name.substr(0, 1)}. ${teacher.last_name}`;
      initials = `${teacher.first_name.substr(0, 1)}${teacher.last_name.substr(0, 1)}`;
    } else {
      displayName = teacher.name;
    }

    return { 
      displayName: displayName,
      initials: initials
    };
  }
);

export default teachersSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/teachers_selector.js
 **/